import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { renderComponent, block } from "../../../core/react";
import { ItemComponent } from './ItemComponents';

var map = require("lodash/map");

var includes = require("lodash/includes");

var sortBy = require("lodash/sortBy");

var minBy = require("lodash/minBy");

var maxBy = require("lodash/maxBy");

var identity = require("lodash/identity");

function computeMinMax(items, field) {
  if (!items || items.length == 0) return {
    min: 0,
    max: 0
  };
  return {
    min: minBy(items, field)[field],
    max: maxBy(items, field)[field]
  };
}

export var TagCloud =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TagCloud, _React$PureComponent);

  function TagCloud() {
    _classCallCheck(this, TagCloud);

    return _possibleConstructorReturn(this, _getPrototypeOf(TagCloud).apply(this, arguments));
  }

  _createClass(TagCloud, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          mod = _this$props.mod,
          className = _this$props.className,
          disabled = _this$props.disabled,
          items = _this$props.items,
          translate = _this$props.translate;
      var bemBlocks = {
        container: block(mod).el,
        option: block("".concat(mod, "-option")).el
      };
      var sortedItems = sortBy(items, function (it) {
        return translate(it.title || it.label || it.key).toLowerCase();
      });

      var _computeMinMax = computeMinMax(items, "doc_count"),
          min = _computeMinMax.min,
          max = _computeMinMax.max;

      return React.createElement("div", {
        className: bemBlocks.container().mix(className).state({
          disabled: disabled
        })
      }, map(sortedItems, function (item) {
        return _this.renderItem(item, bemBlocks, min, max);
      }));
    }
  }, {
    key: "renderItem",
    value: function renderItem(item, bemBlocks, min, max) {
      var _this$props2 = this.props,
          itemComponent = _this$props2.itemComponent,
          minFontSize = _this$props2.minFontSize,
          maxFontSize = _this$props2.maxFontSize,
          showCount = _this$props2.showCount,
          countFormatter = _this$props2.countFormatter,
          _this$props2$selected = _this$props2.selectedItems,
          selectedItems = _this$props2$selected === void 0 ? [] : _this$props2$selected,
          toggleItem = _this$props2.toggleItem,
          disabled = _this$props2.disabled,
          translate = _this$props2.translate;
      var sizeRatio = min === max ? 0.5 : (item.doc_count - min) / (max - min);
      var fontSize = minFontSize + sizeRatio * (maxFontSize - minFontSize); // TODO : make ratio function customizable (square, log, etc.)

      return renderComponent(itemComponent, {
        label: translate(item.title || item.label || item.key),
        onClick: function onClick() {
          return toggleItem(item.key);
        },
        bemBlocks: bemBlocks,
        key: item.key,
        itemKey: item.key,
        disabled: disabled || item.disabled,
        active: includes(selectedItems, item.key),
        style: {
          fontSize: fontSize + 'em'
        },
        showCount: showCount,
        count: countFormatter(item.doc_count)
      });
    }
  }]);

  return TagCloud;
}(React.PureComponent);
TagCloud.defaultProps = {
  mod: "sk-tag-cloud",
  itemComponent: ItemComponent,
  showCount: false,
  minFontSize: 1,
  maxFontSize: 1.5,
  translate: identity,
  countFormatter: identity
};